namespace SolovisGateway.Admin.Authentication {

    /**
     * CommonLoginTargetUrlHelper if given a targetUrl will set it in localStorage so that we can later retrieve it after authenticating with Auth0
     */
    export class CommonLoginTargetUrlHelper {
        private static localStorageKey : string = 'solovis:login:target-url';

        public static getTargetUrl() : string | null {
            let targetUrl: string | null = null;
            targetUrl = window.localStorage.getItem(this.localStorageKey);
            return targetUrl;
        }

        public static setTargetUrl(targetUrl: string | null) : void {
            if(targetUrl) {
                window.localStorage.setItem(this.localStorageKey, targetUrl);
            }
        }

        public static clearTargetUrl(callback: () => void) : void {
            try {
                window.localStorage.removeItem(this.localStorageKey);
            }
            finally {
                if(callback) {
                    callback();
                }
            }
        }
    }
}